module.exports = __webpack_public_path__ + "static/media/no-balustrade.79d08583.jpg";